<template>
  <v-row style="width: 100%">
    <CalcBankInfoDialog :editedItemBank="bankViewData" style="position: absolute" />
    <CalcRateInfoDialog :editedItemProduct="rateViewData" style="position: absolute" />
    <AttentionWindow :calc="calc" :msg="msg" :vid="vid" style="position: absolute" />
    <v-card style="width: 100%; padding-top: 10px">
      <!-- <h2 class="text-center colorblue">
        Предварительный расчет банковской гарантии
      </h2> -->
      <CalcResultParams @CloseDialog="CloseDialog" :calc="calc" />

      <v-divider></v-divider>
      <v-card-title>
        <div class="row no-gutters">
          <div class="col-md-6" style="display: flex; column-gap: 20px; align-items: center"
            @click="setClipboard($store.getters.getCalcRegisterId)">
            <div class="colorblue">
              Предложения банков по заданным параметрам {{ getKolPodhodit1 }}
            </div>
            <v-tooltip right max-width="850">
              <template v-slot:activator="{ on }">
                <v-icon right small v-on="on" style="margin: 0">info</v-icon>
              </template>
              <div>ID Расчета: {{ $store.getters.getCalcRegisterId }}</div>
            </v-tooltip>
          </div>
          <div class="col-md-6 text-right">
            <div style="display: flex; column-gap: 40px; justify-content: end">
              <yearProcentComponent v-model="yearProcent" @change="changeYearProcent" style="margin: 15px 15px 0 0" />
            </div>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table v-model="selected1" :sort-by="['ikomsk']" :headers="headersPodhodit" :items="getPodhodit1"
          item-key="product_id" :disable-pagination="true" :hide-default-footer="true" show-select class="elevation-1">
          <template v-slot:item.bank="{ item }">
            <div style="
                display: grid;
                align-self: center;
                grid-template-columns: 50px 1fr 40px;
                grid-gap: 10px;
              ">
              <img :src="getBankLogo(item.bank_id)" :alt="item.name" width="50" height="50" style="align-self: start" />
              <div style="display: grid">
                <div>
                  <span class="bank_name" style="color: #217899;">{{ item.bank }}
                  </span>

                  <br />
                  <span>{{ item.product }}</span>
                  <br />
                  {{ item.acra }} / {{ item.raexpert }}
                </div>
              </div>
            </div>
          </template>
          <!-- <template v-slot:item.acra="{ item }"
            >{{ item.acra }} / {{ item.raexpert }}</template
          > -->
          <template v-slot:item.bankTags="{ item }">
            <div style="display: flex; column-gap: 7px">
              <span v-for="row of item.bankTags" :key="`${item.id}_${row}`" class="scaleOnHover">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <img v-bind="attrs" v-on="on" :src="getTagImg(row)" :alt="getTag(row)"
                      style="width: 20px; height: 20px" />
                  </template>
                  <span>{{ getTag(row) }}</span>
                </v-tooltip>
              </span>
            </div>
          </template>
          <!-- <template v-slot:item.ikom="{ item }" >
            {{ String(addCommas(item.ikom)).replace(",00", "") }}
            <br />
            <span class="procent">{{
              procent(item.ikom, calc.summ, calc.days, yearProcent)
            }}</span>
          </template> -->
          <template v-slot:item.ikomsk="{ item }">
            {{ String(addCommas(item.ikomsk)).replace(",00", "") }}
            <br />
            <span class="procent">{{
                procent(item.ikomsk, calc.summ, calc.days, yearProcent)
            }}</span>
          </template>
          <template v-slot:item.expert="{ item }">
            {{ String(addCommas(item.expert)).replace(",00", "") }}
            <br />
            <span class="procent">{{
                procent(item.expert, calc.summ, calc.days, yearProcent)
            }}</span>
          </template>
          <!-- <template v-slot:item.ikomClient="props">
            <v-edit-dialog
              large
              :return-value.sync="props.item.ikomClient"
              @open="OnDialogOpen(props)"
              save-text="Записать"
              cancel-text="Отмена"
            >
              <div>
                {{
                  String(addCommas(props.item.ikomClient)).replace(",00", "")
                }}
                <v-icon right small>edit</v-icon>
              </div>
              <template v-slot:input>
                <div class="mt-4 title">Обновить Комиссию</div>
              </template>
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.ikomClient"
                  @focus="OnTextFielsFocus($event)"
                  label="Править"
                  v-mask="'############'"
                  single-line
                ></v-text-field>
              </template>
              <span class="procent">{{
                procent(
                  props.item.ikomClient,
                  calc.summ,
                  calc.days,
                  yearProcent
                )
              }}</span>
            </v-edit-dialog>
          </template> -->


        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions class="pl-5 pr-5">
        <v-btn color="green" @click.stop="sendRequest">Подать заявку</v-btn>
        <!-- <v-btn @click.stop="AttentionWindowForSelected"
          >Скачать расчет по выбранным банкам в xlsx</v-btn
        >
        <v-divider></v-divider>
        <v-btn @click.stop="AttentionWindowForAll"
          >Скачать расчет по всем банкам в xlsx</v-btn
        > -->
        <v-divider></v-divider>
        <v-btn color="orange" @click.stop="newCalculation">Новый расчет</v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import Swal from "sweetalert2";
import CalcBankInfoDialog from "./CalcBankInfoDialog.vue";
import CalcRateInfoDialog from "./CalcRateInfoDialog.vue";
import CalcResultParams from "./CalcResultParams.vue";
import AttentionWindow from "./AttentionWindow.vue";
import yearProcentComponent from "@/components/yearProcent";
import { roleObj } from "@/plugins/roles";

export default {
  components: {
    CalcBankInfoDialog,
    CalcRateInfoDialog,
    AttentionWindow,
    yearProcentComponent,
    CalcResultParams,
  },
  computed: {
    tagsList() {
      return this.$store.getters.getBanksTags;
    },
    vid: {
      get() {
        return this.$store.getters.getVID;
      },
      set(val) {
        this.$store.commit("setVID", val);
      },
    },
    headersPodhodit() {
      return [
        {
          text: "Банк",
          value: "bank",
          // width: "30%",
          class: "nazv_bank",
          sortable: false,
        },
        {
          text: "Тип",
          value: "bankTags",
          width: "80px",
          align: "center",
        },
        {
          text: "Стандартная комиссия",
          value: "ikomsk",
          width: "150px",
          sortable: true,
        },
        {
          text: "Комиссия при подаче заявки через FinExpert",
          value: "expert",
          width: "140px",
          sortable: true,
        },

      ];
    },
    calc() {
      return this.$store.getters.calc;
    },
    dialogMain() {
      return this.$store.getters.getResultDialog;
    },

    // getGarPolzZak() {
    //   const gar_polz_zak = this.$store.getters.calc.gar_polz_zaksVal;
    //   if (!gar_polz_zak) return "-";
    //   return gar_polz_zak.name;
    // },

    getPodhodit1() {
      return this.$store.getters.getPodhodit1 && this.$store.getters.getPodhodit1.length ? this.$store.getters.getPodhodit1.filter(
        (item) => {
          if (item && item.bankTags !== null && item.bankTags !== undefined && item.bankTags.length > 0) {
            return true
          }

          return false
        }
      ).map(item=>{
        item.expert = Number(this.calcFinCommission(item)).toFixed(0)
        return item
      }) : []
    },
    getPodhodit2() {
      return this.$store.getters.getPodhodit2;
    },
    getKolPodhodit1() {
      if (this.getPodhodit1) return this.getPodhodit1.length;
      else return 0;
    },
    getKolPodhodit2() {
      return this.$store.getters.getPodhodit2.length;
    },
    getKolNePodhodit2() {
      return this.$store.getters.getNePodhodit.length;
    },
    getnepodhoditItems() {
      return this.$store.getters.getNePodhodit;
    },
    selected1: {
      get() {
        return this.$store.getters.get_selected1;
      },
      set(val) {
        this.$store.dispatch("SET_SELECTED1", val);
      },
    },
    selected2: {
      get() {
        return this.$store.getters.get_selected2;
      },
      set(val) {
        this.$store.dispatch("SET_SELECTED2", val);
      },
    },
  },
  filters: {
    toIndividual: function (value) {
      if (value == 0 || value == "0") return "индивидуально";
      return value;
    },
    toBool(val) {
      if (val) return "ДА";
      else return "Нет";
    },
  },
  async mounted() {
    this.setTitle(`Предварительный расчет банковской гарантии`);
    // calcreport
    await this.checkBanksLogo();
    if (!this.$store.getters.getBanksTags.length) {
      await this.$store.dispatch("GetBanksTags");
    }

    if (this.$route.query.already === 'true') {
      return
    }

    if (this.$route.query.calcRegisterId) {
      const item = {
        _id: this.$route.query.calcRegisterId,
        table: true,
      };
      await this.sendToCalcResult(item);
    }

    await this.$store.dispatch("GET_RATING_CONFIG");

    if (
      this.$store.getters.calc.summ === "" ||
      this.$store.getters.calc.summ === null
    ) {
      this.$router.push("/calcagent");
    } else {
      await this.changeYearProcent();
    }
  },
  data() {
    return {
      roleObj,
      bankViewData: null,
      rateViewData: null,
      snack: false,
      snackColor: "",
      snackText: "",
      show: false,
      msg: "",
      notifications: false,
      sound: true,
      widgets: false,
      yearProcent: true,
      headersNePodhodit: [
        { text: "Название банка / продукт", value: "bank" },
        { text: "Причина несоответствия параметров продукту", value: "reason" },
      ],
      // getPodhodit1: []
    };
  },
  methods: {
    // calcFinCommission(item, ikomsk) {
    //   // Если базовый тариф меньше или равен минимальному, то выводим без изменений
    //   // Если базовый тариф больше минимального, то умножаем на 0,9 и сравниваем его с минимальным: если он меньше минимального, то выводим минимальный
    //   if (!item.bt_mt) {
    //     return ikomsk
    //   }

    //   if (item.bt_mt.BT <= item.bt_mt.MT) {
    //     return ikomsk
    //   }

    //   if (item.bt_mt.BT > item.bt_mt.MT) {
    //     const res = ikomsk * 0.9
    //     if (res > item.bt_mt.MT) {
    //       return item.bt_mt.MT
    //     }
    //     return res
    //   }
    // },
    calcFinCommission(item) {
      // должно быть = умножить на 0,9 от суммы из первого столбца
      // и в конце результат сравнить с минималкой по банку, если полученная сумма меньше чем минималка, то выводить во второй столбец тоже минималку
      // console.log('bank, ikomsk, MT, item',item.bank,item.ikomsk,item.bt_mt.MT,item);
      if (!item.bt_mt.MT) {
        return parseFloat(item.ikomsk)
      }
      const res = parseFloat(item.ikomsk) * 0.9
      // console.log('bank, res',item.bank, res);

      if (res < item.bt_mt.MT) {
        return item.bt_mt.MT
      }
      return res
    },
    getTag(tagId) {

      return this.tagsList.find((item) => Number(item.id) === Number(tagId) ? true : false).name;
    },
    getTagImg(tagId) {
      switch (Number(tagId)) {
        case 1:
          return "/time.svg";
        case 2:
          return "/cash.svg";
        case 3:
          return "/docs.svg";
      }
    },
    sendRequest() {
      if (
        !this.$store.getters.get_selected1.length &&
        !this.$store.getters.get_selected2.length
      ) {
        Swal.fire({
          icon: "warning",
          title: "Внимание!",
          text: "Не выбран ни один банк.",
        });
        return;
      }

      this.$router.push("/sendrequest");
    },
    setClipboard(val) {
      navigator.clipboard.writeText(val);
    },
    async checkBanksLogo() {
      const logos = this.$store.getters.getBanksLogos;
      !logos.length && (await this.$store.dispatch("GET_BANKS_LOGOS"));
    },
    getBankLogo(bank_id) {
      const logos = this.$store.getters.getBanksLogos;
      const filter = logos.filter((item) => item.id === bank_id);
      return filter.length && filter[0] && filter[0].logo
        ? filter[0].logo
        : null;
    },
    async changeYearProcent() {
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "yearProcent",
        value: this.yearProcent,
      });
    },
    CalculationShow(calc) {
      return this.role() == roleObj.bankir || (roleObj.adminService && calc)
        ? true
        : false;
    },
    newCalculation() {
      this.$store.dispatch("setNewCalculation").then(() => {
        this.$store.dispatch("SET_SELECTED1", []);
        this.$store.dispatch("SET_SELECTED2", []);
        this.$router.push("/calcagent");
      });
      // .catch((error) => {
      //   this.$router.push("/logout");
      //   Swal.fire({
      //     icon: "error",
      //     title: "Сеанс пользователя завершен. ",
      //     text: "Время Вашей сессии истекло, для продолжения работы войдите в личный кабинет заново",
      //   });
      // });
    },
    OnDialogOpen(property) {
      property.item.ikomClient = property.item.ikomsk;
    },
    OnFinSummChange: function (evt) {
      //
      if (evt.key == "Enter") {
        return;
      }
      if (
        (evt.key == "." || evt.key == ",") &&
        (evt.target.value.indexOf(".") != -1 ||
          evt.target.value.indexOf(",") != -1)
      ) {
        event.preventDefault();
        return false;
      }
      var regex = new RegExp("[0-9,. ]");
      var key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },

    AttentionWindowForSelected() {
      if (
        !this.$store.getters.get_selected1.length &&
        !this.$store.getters.get_selected2.length
      ) {
        Swal.fire({
          icon: "warning",
          title: "Внимание!",
          text: "Не выбран ни один банк.",
        });
        return;
      }

      this.vid = 1;
      this.msg =
        "Для формирования xls по выбранным банкам нужно заполнить следующие поля:";
      this.$store.dispatch("setAttentionDIalog", true).then(() => { });
    },
    AttentionWindowForAll() {
      this.vid = 2;
      this.msg =
        "Для формирования xls по всем банкам нужно заполнить следующие поля:";

      this.$store.dispatch("setAttentionDIalog", true).then(() => { });
    },
    SendOrders() {
      this.vid = 3;
      this.msg =
        "Для формирования заявки в банк нужно заполнить следующие поля:";
      this.$store.dispatch("setAttentionDIalog", true).then(() => { });
    },
    CloseDialog() {
      this.genSession();
      this.$store.dispatch("clearResults").then(() => {
        this.$router.push("/calcagent");
      });
    },
    showBankInfo(product_id) {
      this.$store.dispatch("getBankViewData", product_id).then(() => {
        this.bankViewData = this.$store.getters.getbankViewData;
        this.$store.commit("SET_BANK_VIEW_DIALOG", true);
      });
    },
    showRateInfo(item) {
      this.$store.commit("setBankId", item.bank_id);
      this.$store.commit("setBankRate", item.rate);
      this.$store.commit("setProductId", item.product_id);
      this.$store.dispatch("getRateViewData", item.product_id).then(() => {
        this.rateViewData = this.$store.getters.getrateViewData;
        this.$store.commit("SET_RATE_VIEW_DIALOG", true);
      });
    },
  },
  // watch: {
  //   bankTag(newVal, val){
  //
  //     this.getPodhodit1 =
  //   }
  // }
};
</script>

<style lang="scss">
.scaleOnHover {
  transition: all 0.3s linear;

  &:hover {
    transform: scale(1.3);
  }
}

.procent {
  color: #217899;
  font-size: 0.8em;
}

.v-subheader.text-blue.theme--light {
  color: #217899;
}

.text18 {
  font-size: 18px;
}

.paramsTable {
  max-width: 800px;
}

.text-center {
  text-align: center;
}

.colorblue {
  color: #217899;
}

.colorred {
  color: #bd1c32;
}

.theme--light.filledColor.v-input:not(.v-input--is-disabled) input {
  color: #217899;
}

.borderedStyle {
  border: 1px;
  border-style: solid;
}

.calcParam {
  .v-data-table td {
    font-size: 14px;
    height: 35px;
  }

  .selects {
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .v-messages {
    min-height: 0;
  }
}

.centertop {
  padding-top: 35px;
}

.blackclass {
  color: powderblue;
}

.v-input.colorblue {
  color: #217899;
}

#app {

  .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #217899;
  }

  h1 {
    font-size: 1.5rem;
  }

  .bluelink {
    color: #217899;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    .bluelinkNotInderlined {
      color: #217899;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .v-data-table-header tr th {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  @media (min-width: 1380px) {
    .v-data-table-header tr th {
      font-size: 0.85rem;
    }

    .v-dialog table thead tr th {
      font-size: 0.85rem;
    }

    .v-data-table tbody td {
      font-size: 0.85rem;
    }

    .v-card__title {
      font-size: 1.175rem;
    }

    .bank_name {
      font-size: 0.95rem;
    }
  }

  @media (max-width: 1380px) {
    .v-data-table-header tr th {
      font-size: 0.7rem;
    }

    .v-dialog table thead tr th {
      font-size: 0.7rem;
    }

    .v-data-table tbody td {
      font-size: 0.7rem;
    }

    .v-card__title {
      font-size: 1.075rem;
    }

    .bank_name {
      font-size: 0.85rem;
    }
  }

  @media (min-width: 1900px) {
    .v-data-table-header tr th {
      font-size: 1rem;
    }

    .v-dialog table thead tr th {
      font-size: 1rem;
    }

    .v-data-table tbody td {
      font-size: 1rem;
    }

    .v-card__title {
      font-size: 1.2rem;
    }

    .bank_name {
      font-size: 1.1rem;
    }
  }
}
</style>
